import { NgModule } from '@angular/core';
import { BookingMainInformationsComponent } from './booking-main-informations.component';
import { BookingStatusesComponent } from './components/booking-statuses/booking-statuses.component';
import { BookingTimeLineComponent } from "./components/booking-time-line/booking-time-line.component";
import { BookingStatusModule } from 'libraries/component/booking/booking-status/booking-status.module';
import { BtnModule } from "libraries/ui_button/btn.module";
import { CardModule } from 'libraries/ui_card/card.module';
import { CommonModule } from '@angular/common';
import { DatePipeModule } from 'libraries/date/date.module';
import { PermissionModule } from "libraries/permission/permission.module";
import { PriceModule } from 'libraries/component/price/price.module';
import { ReferencesModule } from '../sectors/components/shared/components/references/references.module';
import { BookingActionsMenuComponent } from './components/booking-actions-menu/booking-actions-menu.component';
import { PopupMenuModule } from "libraries/component/popup-menu/popup-menu.module";
import { BookingServiceModule } from 'libraries/service/booking/bookingService.module';
import { NotificationModule } from "libraries/component/notification/notification.module";
import { BrowserClipboardModule } from 'libraries/service/browserClipboard/browserClipboard.module';
import { TextExportDialogModule } from 'libraries/component/dialogs/text-export-dialog/text-export-dialog.module';
import { PlainTextModule } from 'libraries/service/plainText/plaintText.module';
import { ConfirmDialogModule } from "libraries/component/dialogs/confirm-dialog/confirm-dialog.module";
import { HostAliasPipeModule } from "libraries/pipes/host-alias/host-alias-pipe.module";
import { MatDialogModule } from "@angular/material/dialog";
import { MatMenuModule } from "@angular/material/menu";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { PipesModule } from "libraries/pipes/pipes.module";
import { CarbonFootprintModule } from "libraries/component/carbon-footprint/carbon-footprint.module";
import {
    FareOptimisationSummaryModule
} from "libraries/component/booking-information/components/booking-fare-optimisation-card/components/fare-optimisation-summary/fare-optimisation-summary.module";
import { InterfaceFlagModule } from "libraries/component/interface-flag/interface-flag.module";


@NgModule({
    imports: [
        BookingServiceModule,
        BookingStatusModule,
        BtnModule,
        CardModule,
        CommonModule,
        DatePipeModule,
        MatDialogModule,
        PermissionModule,
        PriceModule,
        ReferencesModule,
        MatMenuModule,
        PopupMenuModule,
        NotificationModule,
        BrowserClipboardModule,
        PlainTextModule,
        TextExportDialogModule,
        ConfirmDialogModule,
        HostAliasPipeModule,
        FontAwesomeModule,
        PipesModule,
        CarbonFootprintModule,
        InterfaceFlagModule,
        FareOptimisationSummaryModule,
    ],
    declarations: [
        BookingMainInformationsComponent,
        BookingStatusesComponent,
        BookingActionsMenuComponent,
        BookingTimeLineComponent,
    ],
    exports: [
        BookingMainInformationsComponent,
    ]
})
export class BookingMainInformationsModule {
}
